import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  GetAutocompleteResultsMutation,
  GetAutocompleteResultsMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';

export const GET_AUTOCOMPLETE_SUGGESTIONS = graphql(`
  mutation GetAutocompleteResults(
    $language: String!
    $location: String
    $placeId: String
    $country: String
  ) {
    autocompleteSuggestions(
      language: $language
      location: $location
      placeId: $placeId
      country: $country
    ) {
      placeId
      lon
      lat
      label
    }
  }
`);

export const useGetAutocompleteResults = () => {
  const [mutate, { loading, error }] = useMutation<
    GetAutocompleteResultsMutation,
    GetAutocompleteResultsMutationVariables
  >(GET_AUTOCOMPLETE_SUGGESTIONS);

  const getAutocompleteSuggestions = useCallback(
    async (params: GetAutocompleteResultsMutationVariables) => {
      return mutate({
        variables: params,
      });
    },
    [mutate],
  );
  return {
    getAutocompleteSuggestions,
    suggestionsError: error,
    suggestionsLoading: loading,
  };
};
